// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --minimumWidth:20rem;
  --borderRadiusBarelyRounded:0.125rem;
  --borderRadiusSomewhatRounded:0.19rem;
  --borderRadiusSemiSquare:0.25rem;
  --borderRadiusSemiRounded:0.5rem;
  --borderRadiusRounded:1rem;
  --borderRadiusCircle:50%;
  --containerBoxShadow:0 2px 2px var(--colorLightBoxShadow);
  --lightBoxShadow:0 0 4px var(--colorGreyLighterTransparent);
  --darkBoxShadow:0 0 4px var(--colorGreyLightTransparent);
  --toastBoxShadow:0 3px 12px rgb(0, 0, 0, 0.2);
  --tableRowHeight:3rem;
  --minPageHeight:60vh;
  --maxWidthNarrow:608px;
  --maxWidthDefault:1024px;
  --defaultGutter:var(--spacer);
  --defaultGutterLarge:var(--one-and-half-spacer);
}

.panel{
  width:100%;
}

.panel:not(.panel--flat){
    padding-top:1rem;
    padding-bottom:1rem;
  }

.panel--fluid{
    padding:0 1rem;
  }

@media (width > 640px){

.panel--fluid{
    padding:0 1.5rem;
  }
  }

.panel--centered,
  .panel--narrow{
    padding:0 1rem;
  }

@media (width > 640px){

.panel--centered,
  .panel--narrow{
    padding:0 1.5rem;
  }
  }

.panel--centered .panel__content, .panel--narrow .panel__content{
      margin:0 auto;
    }

.panel--centered .panel__content{
      max-width:1024px;
    }

.panel--narrow .panel__content{
      max-width:608px;
    }

.panel--flat{
    display:unset;
  }

.panel--fill{
    min-height:100%;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
